import angular from 'angular';

const COMPACT = 'timeline-filter-pills--compact';

const wraps = (bar: HTMLElement) => {
	const items = Array.from(bar.children);
	if (items.length < 2) {
		return false;
	}
	const firstLineBottom = items[0].getBoundingClientRect().bottom;
	return items.some(item => item.getBoundingClientRect().top >= firstLineBottom);
};

// A bar too narrow for even one pill beside the title drops below it instead of wrapping.
const belowTitle = (bar: HTMLElement) => {
	const title = bar.previousElementSibling;
	return !!title && bar.getBoundingClientRect().top >= title.getBoundingClientRect().bottom;
};

// Shows the card history bar's labels only while the labelled bar fits on one line,
// and falls back to icon + count otherwise. Pill counts and language both change the
// width, so this measures the bar instead of guessing a viewport breakpoint.
angular.module('upDirectives').directive('upFitLabels', () => ({
	restrict: 'A',
	link: (scope: angular.IScope, element: JQLite) => {
		const bar = element[0];
		let frame = 0;
		let destroyed = false;

		const fit = () => {
			frame = 0;
			bar.classList.remove(COMPACT);
			bar.classList.toggle(COMPACT, wraps(bar) || belowTitle(bar));
		};
		// Deferred to a frame so a toggle never re-enters its own ResizeObserver callback.
		const schedule = () => {
			if (!destroyed) {
				frame ||= requestAnimationFrame(fit);
			}
		};

		// The bar fills the space beside the title, so its width follows both the column and the title.
		const resizeObserver = new ResizeObserver(schedule);
		resizeObserver.observe(bar);
		// Pills appear as their counts load, and counts change their width.
		const mutationObserver = new MutationObserver(schedule);
		mutationObserver.observe(bar, { childList: true, subtree: true, characterData: true });
		// A web font landing changes the labels' width without resizing the bar or touching its DOM.
		document.fonts.ready.then(schedule);

		scope.$on('$destroy', () => {
			destroyed = true;
			cancelAnimationFrame(frame);
			resizeObserver.disconnect();
			mutationObserver.disconnect();
		});
	}
}));
